import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, shareReplay } from "rxjs";
import { CategoryResponse } from "../../categories/interfaces/categories.interface";
import { environment } from "../../../../../../environments/environment";

@Injectable
  ({ 'providedIn': 'root' })
export class ListCategoriesService {
  private http = inject(HttpClient);

  getCategories(establishmentId: number): Observable<CategoryResponse> {
    return this.http.get<CategoryResponse>(`${environment.apiUrl}/products/categories/${establishmentId}`).pipe(
      shareReplay({
        bufferSize: 1,
        refCount: true
      })
    );
  }

}
